// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2k_RZ","requiredAsterisk":"Info_requiredAsterisk__1UJwf"};